import { useStaticQuery, graphql } from 'gatsby'
import { camelize } from '../utils'

//----------------!!!!!!! **** INFO **** !!!!!!!----------------------
//This hook takes a type(s) from global resources in contentful and a node locale
//This filters based on type and returns an object with all the text from that type

//Query like this in any file you need to use the dictionary

// const {
//   cart: { discount },
//   product: { size },
// } = useGlobal(['cart', 'product'], node_locale)
//--------------------------------------

export const useGlobal = (categories, nodeLocale = 'en') => {
  const {
    allContentfulGlobalResourceGroup: { edges },
  } = useStaticQuery(
    graphql`
      query global {
        allContentfulGlobalResourceGroup {
          edges {
            node {
              node_locale
              title
              resources {
                node_locale
                title
                text
                source
                list
                singleLink {
                  ... on ContentfulMenu {
                    id
                    title
                    links {
                      id
                      title
                      image {
                        file {
                          url
                        }
                        fluid {
                          aspectRatio
                          src
                          srcSet
                          srcWebp
                          srcSetWebp
                          sizes
                        }
                      }
                      linkExtension
                      availableInCountry
                      target {
                        ... on ContentfulCollection {
                          slug
                        }
                        ... on ContentfulTechnologyPage {
                          slug
                        }
                        ... on ContentfulFaqPage {
                          slug
                        }
                        ... on ContentfulTextPage {
                          slug
                        }
                        ... on ContentfulAboutPage {
                          slug
                        }
                        ... on ContentfulBlogPage {
                          slug
                        }
                        ... on ContentfulStoresPage {
                          slug
                        }
                        ... on ContentfulPage {
                          slug
                        }
                        ... on ContentfulProduct {
                          slug
                        }
                      }
                    }
                  }
                  ... on ContentfulLink {
                    id
                    title
                    image {
                      file {
                        url
                      }
                      fluid {
                        aspectRatio
                        src
                        srcSet
                        srcWebp
                        srcSetWebp
                        sizes
                      }
                    }
                    linkExtension
                    availableInCountry
                    target {
                      ... on ContentfulCollection {
                        slug
                      }
                      ... on ContentfulTechnologyPage {
                        slug
                      }
                      ... on ContentfulFaqPage {
                        slug
                      }
                      ... on ContentfulTextPage {
                        slug
                      }
                      ... on ContentfulAboutPage {
                        slug
                      }
                      ... on ContentfulBlogPage {
                        slug
                      }
                      ... on ContentfulStoresPage {
                        slug
                      }
                      ... on ContentfulPage {
                        slug
                      }
                      ... on ContentfulProduct {
                        slug
                      }
                    }
                  }
                }
                linkGroup {
                  ... on ContentfulAnnouncementItem {
                    availableInCountry
                    id
                    text
                    richText {
                      raw
                    }
                    svg {
                      file {
                        url
                      }
                      svg {
                        content
                      }
                    }
                    link {
                      id
                      image {
                        file {
                          url
                        }
                        fluid {
                          aspectRatio
                          src
                          srcSet
                          srcWebp
                          srcSetWebp
                          sizes
                        }
                      }
                      linkExtension
                      availableInCountry
                      target {
                        ... on ContentfulCollection {
                          slug
                        }
                        ... on ContentfulTechnologyPage {
                          slug
                        }
                        ... on ContentfulFaqPage {
                          slug
                        }
                        ... on ContentfulTextPage {
                          slug
                        }
                        ... on ContentfulAboutPage {
                          slug
                        }
                        ... on ContentfulBlogPage {
                          slug
                        }
                        ... on ContentfulStoresPage {
                          slug
                        }
                        ... on ContentfulPage {
                          slug
                        }
                        ... on ContentfulProduct {
                          slug
                        }
                      }
                    }
                  }
                  ... on ContentfulLink {
                    id
                    title
                    image {
                      file {
                        url
                      }
                      fluid {
                        aspectRatio
                        src
                        srcSet
                        srcWebp
                        srcSetWebp
                        sizes
                      }
                    }
                    linkExtension
                    availableInCountry
                    target {
                      ... on ContentfulCollection {
                        slug
                      }
                      ... on ContentfulTechnologyPage {
                        slug
                      }
                      ... on ContentfulFaqPage {
                        slug
                      }
                      ... on ContentfulTextPage {
                        slug
                      }
                      ... on ContentfulAboutPage {
                        slug
                      }
                      ... on ContentfulBlogPage {
                        slug
                      }
                      ... on ContentfulStoresPage {
                        slug
                      }
                      ... on ContentfulPage {
                        slug
                      }
                      ... on ContentfulProduct {
                        slug
                      }
                    }
                  }
                  ... on ContentfulMenu {
                    availableInCountry
                    id
                    title
                    links {
                      id
                      title
                      image {
                        file {
                          url
                        }
                        fluid {
                          aspectRatio
                          src
                          srcSet
                          srcWebp
                          srcSetWebp
                          sizes
                        }
                      }
                      linkExtension
                      availableInCountry
                      target {
                        ... on ContentfulCollection {
                          slug
                        }
                        ... on ContentfulTechnologyPage {
                          slug
                        }
                        ... on ContentfulFaqPage {
                          slug
                        }
                        ... on ContentfulTextPage {
                          slug
                        }
                        ... on ContentfulAboutPage {
                          slug
                        }
                        ... on ContentfulBlogPage {
                          slug
                        }
                        ... on ContentfulStoresPage {
                          slug
                        }
                        ... on ContentfulPage {
                          slug
                        }
                        ... on ContentfulProduct {
                          slug
                        }
                      }
                    }
                  }
                }
                richText {
                  raw
                  references {
                    ... on ContentfulPage {
                      contentful_id
                      slug
                    }
                    ... on ContentfulTextPage {
                      slug
                      contentful_id
                    }
                  }
                }
                longText {
                  longText
                }
                mediaMany {
                  file {
                    url
                  }
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                  }
                }
                image {
                  file {
                    url
                  }
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                  }
                }
                shopifyProduct {
                  handle
                }
                boolean
              }
            }
          }
        }
      }
    `,
  )

  let filteredGlobalLayoutQuery = edges.filter(
    ({ node: { node_locale } }) => node_locale === nodeLocale,
  )

  const returnedResource = (object, resource) => {
    const title = camelize(resource.title)
    const source = camelize(resource.source)

    // Check type of value, to avoid Boolean(false) returning the error message
    const value =
      typeof resource[source] !== undefined
        ? resource[source]
        : `Cant find ${source} of ${title}`

    return { ...object, [title]: value }
  }

  const data = categories.reduce((object, categorie) => {
    const title = camelize(categorie)
    return {
      ...object,
      [title]:
        filteredGlobalLayoutQuery
          .find(({ node }) => camelize(node.title) === title)
          ?.node?.resources?.reduce(returnedResource, {}) || {},
    }
  }, {})

  // -- UNCOMMENT TO SEE WHAT DATA IS IN WHAT SECTION -- //
  // console.log('i am data', data)

  return data
}
